import { render, staticRenderFns } from "./Tokens.vue?vue&type=template&id=a95031ac&scoped=true&"
import script from "./Tokens.vue?vue&type=script&lang=js&"
export * from "./Tokens.vue?vue&type=script&lang=js&"
import style0 from "./Tokens.vue?vue&type=style&index=0&id=a95031ac&lang=scss&scoped=true&"
import style1 from "./Tokens.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95031ac",
  null
  
)

export default component.exports